module.exports = "/frontend/img/powered-by-vox-de-l-3x.png";